<script setup lang="ts">
import HeaderAccount from "@components/header/HeaderAccount.vue";
import HeaderCart from "@components/header/HeaderCart.vue";
import HeaderMobileMenu from "@components/header/HeaderMobileMenu.vue";
import HeaderNavigation from "@components/header/HeaderNavigation.vue";
import HeaderSearch from "@components/header/HeaderSearch.vue";
import { cn } from "@shared/lib/utils";
import { useWindowScroll } from "@vueuse/core";
import { computed } from "vue";

// Scroll Handling
const { y } = useWindowScroll();

const isFixed = computed(() => y.value > 50);
</script>

<template>
  <header :class="cn('relative lg:py-[47px]', isFixed && 'h-[80px] lg:h-[175px]')">
    <div
      :class="
        cn(
          'relative bg-background transition-all',
          isFixed && 'fixed left-0 right-0 top-0 z-50 animate-movedown shadow-lg',
        )
      "
    >
      <div
        :class="
          cn(
            'container flex items-center justify-between py-3 lg:items-end',
            isFixed ? 'h-[70px]' : 'h-[80px]',
          )
        "
      >
        <!-- Left Side: Product Category -->
        <HeaderNavigation />

        <!-- Mobile Menu -->
        <HeaderMobileMenu />

        <!-- Center Logo -->
        <RouterLink to="/" class="absolute left-1/2 -translate-x-1/2">
          <img
            src="@assets/images/common/logo-molly.svg"
            width="130"
            height="130"
            alt="Molly Factory logo"
          />
        </RouterLink>

        <!-- Right Side: Search, Cart, Account -->
        <div class="flex items-center gap-4">
          <HeaderSearch />
          <HeaderCart />
          <HeaderAccount />
        </div>
      </div>
    </div>
  </header>
</template>
